// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".object-description{font-size:12px;line-height:1.5;color:var(--black)}@media(min-width:640px){.object-description{font-size:14px}}.object-description>*{margin-bottom:0}.object-description blockquote{border-left:4px solid var(--primary);padding:7px 0 7px 15px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
